import {Component} from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'kt-project-not-found',
    templateUrl: './project-not-found.dialog.component.html'
})
export class ProjectNotFoundDialogComponent {

    constructor(
        private router: Router,
    ) {
    }

    onClick() {
        this.router.navigate(['/dashboard']);
    }
}
